let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7y5Lf")).then(() => parcelRequire('5D4WI'));